<template>
  <div class="homePage">
    <header>
      <h1>
        <span>PHOENIX ENGINEERING TESTS</span>
      </h1>
      <p>Ut quaestiones sint ultimum principium cogitandi</p>

      <div class="flags">
        <span class="radioImage">
          <label class="insideLables">
            <input
              type="radio"
              name="langOption"
              v-model="languageChoice"
              value="en-GB"
              checked="checked"
              @change="setLocale"
            >
            <img class="imageFlags" src="@/assets/UK.png">
          </label>
        </span>

        <span class="radioImage">
          <label class="insideLables">
            <input
              type="radio"
              name="langOption"
              v-model="languageChoice"
              value="nl-NL"
              @change="setLocale"
            >
            <img class="imageFlags" src="@/assets/NL.jpg">
          </label>
        </span>
      </div>
    </header>
    <div class="linkWrap">
      <div class="linkChoice">
        <router-link :to="{ name: 'register' }" class="link">
          <img class="linkImage" src="@/assets/signUp.png" alt="Sign up">
          <h3>{{ t("signUp") }}</h3>
        </router-link>
      </div>
      <div class="linkChoice" id="lastLink">
        <router-link :to="{ name: 'login' }" class="link">
          <img class="linkImage" src="@/assets/courses.png" alt="Tests">
          <h3>{{ t("goToTests") }}</h3>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { authComputed } from "../store/helpers.js";
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },

  data() {
    return {
      languageChoice: "en-GB"
    };
  },

  computed: {
    ...authComputed
  },
  methods: {
    logOut() {
      this.$store.dispatch("logOut");
    },
    setLocale() {
      this.$store.commit("SET_LANGUAGE", this.languageChoice);
    }
  },
  created() {
    this.$store.commit("SET_LANGUAGE", this.languageChoice);
  }
};
</script>

<i18n>
{
  "en-GB": {
    "signUp": "SIGN UP",
    "goToTests": "GO TO TESTS"
  },
  "nl-NL": {
    "signUp": "INSCHRIJVEN",
    "goToTests": "NAAR TESTEN"
  }
}
</i18n>

<style scoped>
.homePage {
  background-image: url("https://phoenix-engineering.be/wp-content/uploads/2019/07/shutterstock_1113165392.png");
  background-size: cover;
  background-position: unset;
  background-repeat: no-repeat;
  min-height: 100vh;
}

header {
  display: flex;
  flex-direction: column;
  background-color: rgb(41, 41, 42);
  text-align: center;
  height: 31vh;
  min-height: 250px;
  position: relative;
  opacity: 0.95;
}
/* -------------------------------------------------------------------------------------Flags---------------------------------------------------------------------------------------- */
.flags {
  position: absolute;
  top: 0;
  right: 0;
  margin: 40px;
}

.radioImage {
  margin-left: 10px;
  margin-right: 10px;
  display: inline-block;
}

.imageFlags {
  opacity: 0.6;
  width: 29px;
  height: 19px;
}
.imageFlags:hover {
  opacity: 1;
}

.radioImage:hover {
  transform: scale(1.02);
  opacity: 1;
}

/* ------------------------------------------------------------------------------------------------------------------------------------------------------ */
h1 {
  font-family: "EB Garamond", serif;
  text-transform: uppercase;
  font-weight: 100;

  font-size: 50px;
  display: inline-block;
  color: white;
  margin-top: 80px;
  margin-left: 30px;
  margin-right: 30px;
  padding-bottom: 5px;
}

h1 span {
  line-height: 60px;
  padding-bottom: 5px;
  border-bottom: solid 3px rgb(218, 0, 55);
}

p {
  color: white;
}

.linkWrap {
  display: flex 1 1;
}

.linkChoice {
  display: inline-flex;
  margin: 10vw;
  margin-top: 15vh;
  cursor: pointer;

  border-style: solid;
  border-color: rgb(62, 62, 62);

  background-color: grey;
  opacity: 1;
}

h3 {
  font-size: 16px;
  font-weight: 100;
  letter-spacing: 1px;
  max-width: 100%;
  margin: 0px;
  padding: 13px;
  color: white;
  background-color: rgb(41, 41, 42);
}

.link {
  text-decoration: none;
}

.linkImage {
  width: 300px;
  opacity: 1;
  margin-top: 0px;
  margin-bottom: -5px;
}

.linkChoice:hover {
  transform: scale(1.05);
}
.link:hover > .linkImage {
  opacity: 1;
}

/*-----------------------------------------------------------------------Make a radio button appear as an image-------------------------------------------------------------------------*/

[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* CHECKED STYLES */
[type="radio"]:checked + img {
  transform: scale(1.1);
  opacity: 1;
}

@media screen and (max-width: 1700px) {
  h1 {
    font-size: 45px;
    margin-top: 8vh;
  }
  .linkChoice {
    margin: 10vw;
    margin-top: 17vh;
  }
  .link {
    text-decoration: none;
  }
  .linkImage {
    width: 280px;
  }
}

@media screen and (max-width: 1500px) {
  h1 {
    font-size: 40px;
    margin-top: 10vh;
  }
  .linkChoice {
    margin: 10vw;
    margin-top: 17vh;
  }

  .linkImage {
    width: 260px;
    opacity: 0.8;
    margin-top: 0px;
    margin-bottom: -5px;
  }
  .linkChoice:hover {
    transform: scale(1.05);
  }
  .link:hover > .linkImage {
    opacity: 1;
  }
}
@media screen and (max-width: 1300px) {
  header {
    min-height: 200px;
  }

  h1 {
    font-size: 40px;
  }
  .linkChoice {
    margin: 10vw;
    margin-top: 15vh;
    margin-bottom: 100px;
  }
  .link {
    text-decoration: none;
  }
  .linkImage {
    width: 260px;
    opacity: 0.8;
    margin-top: 0px;
    margin-bottom: -5px;
  }
  .linkChoice:hover {
    transform: scale(1.05);
  }
  .link:hover > .linkImage {
    opacity: 1;
  }
}

@media screen and (max-width: 990px) {
  header {
    height: 32vh;
  }
  h1 {
    font-size: 38px;
    margin-top: 8vh;
    margin-bottom: 2vh;
  }
  .flags {
    position: relative;
    margin: 0px;
  }
  p {
    margin-top: 0px;
    margin-bottom: 30px;
  }
  .linkChoice {
    margin: 7vw;
    margin-top: 16vh;
    margin-bottom: 0px;
  }
  .link {
    text-decoration: none;
  }

  .linkImage {
    width: 260px;
    opacity: 0.8;
    margin-top: 0px;
  }
  .linkChoice:hover {
    transform: scale(1.05);
  }
  .link:hover > .linkImage {
    opacity: 1;
  }
}
@media screen and (max-width: 720px) {
  header {
    height: 300px;
  }

  h1 {
    font-size: 35px;
    margin-top: 70px;
  }
  #lastLink {
    margin-bottom: 16vh;
  }
  p {
    margin-bottom: 15px;
  }
}
@media screen and (max-width: 590px) {
  h1 {
    margin-top: 60px;
    font-size: 30px;
  }
  h3 {
    font-size: 13px;
  }
  p {
    font-size: 15px;
    margin-bottom: 40px;
  }
}
@media screen and (max-width: 517px) {
  h1 {
    margin-top: 40px;
  }
  p {
    font-size: 15px;
    margin-bottom: 25px;
  }
}

@media screen and (max-width: 445px) {
  h1 {
    font-size: 28px;
    margin-bottom: 1vh;
    margin-left: 15px;
    margin-right: 15px;
  }
  p {
    margin-bottom: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }
}
@media screen and (max-width: 345px) {
  header {
    height: 270px;
  }
  h1 {
    font-size: 24px;
    margin-top: 20px;
    margin-left: 25px;
    margin-right: 25px;
  }
  p {
    font-size: 13px;
  }
  .imageFlags {
    scale: 0.9;
  }
}
@media screen and (max-width: 305px) {
  h1 {
    margin-top: 20px;
    font-size: 22px;
  }

  p {
    font-size: 12px;
  }

  .linkChoice {
    margin-top: 60px;
  }

  .linkImage {
    width: 220px;
  }
}
</style>